/**
 * Lien d'achat `/buy/:slug` d'un produit (pure, client + serveur) : la fiche produit de
 * l'admin l'affiche, `resolveBuySignupRedirect` (`oneshot-checkout.ts`) le sert.
 */

/** Slug d'URL → code licence : "starter-one-shot" → "STARTER_ONE_SHOT". */
export function slugToLicenceCode(slug: string): string {
  return slug.trim().toUpperCase().replace(/-/g, "_");
}

/** Code licence → slug d'URL : "PREMIUM_MONTHLY" → "premium-monthly". */
export function licenceCodeToSlug(code: string): string {
  return code.trim().toLowerCase().replace(/_/g, "-");
}

export type BuyLinkProblem = "noCode" | "trial" | "addon" | "inactive" | "noZohoPlan";

/**
 * Pourquoi un produit n'a pas de lien d'achat (pure, client + serveur) ; `null` = lien valide.
 * Un champ absent (formulaire de création) compte comme vide ; `isActive` absent = actif.
 */
export function buyLinkProblem(product: {
  code?: string | null;
  isActive?: boolean | null;
  isTrial?: boolean | null;
  tier?: string | null;
  zohoPlanCode?: string | null;
}): BuyLinkProblem | null {
  if (!product.code?.trim()) return "noCode";
  if (product.isTrial) return "trial";
  if (product.tier === "addon") return "addon";
  if (product.isActive === false) return "inactive";
  if (!product.zohoPlanCode?.trim()) return "noZohoPlan";
  return null;
}
